/**
 * @generated SignedSource<<12994f3667463dd9850eee7ecc0f13fe>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type salesChannelSwitchQueriesCustomPlanOutcomeQuery$variables = {
  id: string;
};
export type salesChannelSwitchQueriesCustomPlanOutcomeQuery$data = {
  readonly productSwitcherTask: {
    readonly extraData: {
      readonly customPlan: {
        readonly financialPreview: {
          readonly chargedByThisEndpoint: number;
          readonly currentPlan: {
            readonly currencyCode: string;
            readonly monthlyPrice: number;
          };
          readonly isEstimate: boolean;
          readonly newPlan: {
            readonly currencyCode: string;
            readonly monthlyPrice: number;
          };
          readonly paymentOnPlanChange: {
            readonly currencyCode: string;
            readonly estimatedCreditApplied: number;
            readonly estimatedNetAmount: number;
            readonly estimatedRefundValue: number;
            readonly mode: string;
            readonly nextRenewalAmount: number;
            readonly nextRenewalAtUtc: string | null;
          };
          readonly proration: {
            readonly available: boolean;
            readonly currencyCode: string;
            readonly estimatedUnusedAmount: number;
            readonly estimatedUnusedAmountInNewCurrency: number;
            readonly newCurrencyCode: string;
            readonly requiresManualSettlement: boolean;
          };
          readonly warnings: ReadonlyArray<string>;
        };
        readonly planID: number;
      } | null;
      readonly reusedPlanID: number | null;
    };
    readonly id: string;
  } | null;
};
export type salesChannelSwitchQueriesCustomPlanOutcomeQuery = {
  response: salesChannelSwitchQueriesCustomPlanOutcomeQuery$data;
  variables: salesChannelSwitchQueriesCustomPlanOutcomeQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "currencyCode",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "monthlyPrice",
    "storageKey": null
  },
  (v1/*:: as any*/)
],
v3 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "ProductSwitcherTask",
    "kind": "LinkedField",
    "name": "productSwitcherTask",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ProductSwitcherTaskExtraData",
        "kind": "LinkedField",
        "name": "extraData",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "reusedPlanID",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "CreateCustomPlanForSellerResponse",
            "kind": "LinkedField",
            "name": "customPlan",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "planID",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "CustomPlanChangePreview",
                "kind": "LinkedField",
                "name": "financialPreview",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isEstimate",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "chargedByThisEndpoint",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "CustomPlanPricePreview",
                    "kind": "LinkedField",
                    "name": "currentPlan",
                    "plural": false,
                    "selections": (v2/*:: as any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "CustomPlanPricePreview",
                    "kind": "LinkedField",
                    "name": "newPlan",
                    "plural": false,
                    "selections": (v2/*:: as any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "CustomPlanProrationPreview",
                    "kind": "LinkedField",
                    "name": "proration",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "available",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "estimatedUnusedAmount",
                        "storageKey": null
                      },
                      (v1/*:: as any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "estimatedUnusedAmountInNewCurrency",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "newCurrencyCode",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "requiresManualSettlement",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "CustomPlanPaymentPreview",
                    "kind": "LinkedField",
                    "name": "paymentOnPlanChange",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "mode",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "estimatedCreditApplied",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "estimatedRefundValue",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "estimatedNetAmount",
                        "storageKey": null
                      },
                      (v1/*:: as any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "nextRenewalAtUtc",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "nextRenewalAmount",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "warnings",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "salesChannelSwitchQueriesCustomPlanOutcomeQuery",
    "selections": (v3/*:: as any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "salesChannelSwitchQueriesCustomPlanOutcomeQuery",
    "selections": (v3/*:: as any*/)
  },
  "params": {
    "cacheID": "e11924c7970b7892fc1bf743249fa428",
    "id": null,
    "metadata": {},
    "name": "salesChannelSwitchQueriesCustomPlanOutcomeQuery",
    "operationKind": "query",
    "text": "query salesChannelSwitchQueriesCustomPlanOutcomeQuery(\n  $id: ID!\n) {\n  productSwitcherTask(id: $id) {\n    id\n    extraData {\n      reusedPlanID\n      customPlan {\n        planID\n        financialPreview {\n          isEstimate\n          chargedByThisEndpoint\n          currentPlan {\n            monthlyPrice\n            currencyCode\n          }\n          newPlan {\n            monthlyPrice\n            currencyCode\n          }\n          proration {\n            available\n            estimatedUnusedAmount\n            currencyCode\n            estimatedUnusedAmountInNewCurrency\n            newCurrencyCode\n            requiresManualSettlement\n          }\n          paymentOnPlanChange {\n            mode\n            estimatedCreditApplied\n            estimatedRefundValue\n            estimatedNetAmount\n            currencyCode\n            nextRenewalAtUtc\n            nextRenewalAmount\n          }\n          warnings\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "51ba60ba192a8cc50d8d9a467c7227aa";

export default node;
